/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Datetimebeforetodayaspect14Inputs */



/**

* @param {_Filter_Class_Datetimebeforetodayaspect14Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_datetimebeforetodayaspect14 = /** @type {((inputs?: _Filter_Class_Datetimebeforetodayaspect14Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Datetimebeforetodayaspect14Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("vor heute relativ")
});
export { _filter_class_datetimebeforetodayaspect14 as "_filter_class_DateTimeBEFORETODAYAspect" }